import { render, staticRenderFns } from "./BaseTemp.vue?vue&type=template&id=1fa14add&scoped=true"
import script from "./BaseTemp.vue?vue&type=script&lang=js"
export * from "./BaseTemp.vue?vue&type=script&lang=js"
import style0 from "./BaseTemp.vue?vue&type=style&index=0&id=1fa14add&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa14add",
  null
  
)

export default component.exports